import { IRoute } from './types';

import dynamic from './dynamic';

enum RoutePath {
  ONBOARDING = '/wizard/',
  MEDIA_SOURCE = '/wizard/media-source',
  MEDIA_IMPORT = '/wizard/media-import',
  MEDIA_PREVIEW = '/wizard/media-preview',
  CUSTOMIZE_VIDEO_THEME = '/wizard/customize-video-theme',
  CUSTOMIZE_VIDEO_STYLE = '/wizard/customize-video-style',
  CUSTOMIZE_VIDEO_MUSIC = '/wizard/customize-video-music',
  CUSTOMIZE_VIDEO_TEXT = '/wizard/customize-video-text',
  BUSINESS_INFO = '/wizard/business-info',
  VIDEO_CREATING = '/wizard/video-creating',
  REVIEW_VIDEO = '/wizard/review-video',
  FINAL_PAGE = '/wizard/final-page',
  SITE_PREVIEW = '/wizard/site-preview',
}

// TODO: rethink wizard routes + routes guards (requireSessionId, requireSessionId).
// Mb array of routes is not the best structure?
const wizardRoutes: IRoute[] = [
  {
    path: RoutePath.ONBOARDING,
    component: dynamic(
      () =>
        import(
          /* webpackChunkName: "onboarding" */
          '../pages/Onboarding/Onboarding'
        ),
    ),
    requireLogin: false,
    requireSessionId: true,
  },
  {
    path: RoutePath.MEDIA_SOURCE,
    component: dynamic(
      () =>
        import(
          /* webpackChunkName: "media-source" */
          '../pages/MediaSource/MediaSource'
        ),
    ),
    requireLogin: true,
    requireSessionId: true,
  },
  {
    path: RoutePath.MEDIA_IMPORT,
    component: dynamic(
      () =>
        import(
          /* webpackChunkName: "media-import" */
          '../pages/MediaImport/MediaImport'
        ),
    ),
    requireLogin: true,
    requireSessionId: true,
  },
  {
    path: RoutePath.MEDIA_PREVIEW,
    component: dynamic(
      () =>
        import(
          /* webpackChunkName: "media-preview" */
          '../pages/MediaPreview/MediaPreview'
        ),
    ),
    requireLogin: true,
    requireSessionId: true,
  },
  {
    path: RoutePath.CUSTOMIZE_VIDEO_THEME,
    component: dynamic(
      () =>
        import(
          /* webpackChunkName: "customize-video-theme" */
          '../pages/CustomizeVideoTheme/CustomizeVideoTheme'
        ),
    ),
    requireLogin: true,
    requireSessionId: true,
  },
  {
    path: RoutePath.CUSTOMIZE_VIDEO_STYLE,
    component: dynamic(
      () =>
        import(
          /* webpackChunkName: "customize-video-style" */
          '../pages/CustomizeVideoStyle/CustomizeVideoStyle'
        ),
    ),
    requireLogin: true,
    requireSessionId: true,
  },
  {
    path: RoutePath.CUSTOMIZE_VIDEO_MUSIC,
    component: dynamic(
      () =>
        import(
          /* webpackChunkName: "customize-video-music" */
          '../pages/CustomizeVideoMusic/CustomizeVideoMusic'
        ),
    ),
    requireLogin: true,
    requireSessionId: true,
  },
  {
    path: RoutePath.CUSTOMIZE_VIDEO_TEXT,
    component: dynamic(
      () =>
        import(
          /* webpackChunkName: "customize-video-text" */
          '../pages/CustomizeVideoText/CustomizeVideoText'
        ),
    ),
    requireLogin: true,
    requireSessionId: true,
  },
  {
    path: RoutePath.BUSINESS_INFO,
    component: dynamic(
      () =>
        import(
          /* webpackChunkName: "business-info" */
          '../pages/BusinessInfo/BusinessInfo'
        ),
    ),
    requireLogin: true,
    requireSessionId: true,
  },
  {
    path: RoutePath.VIDEO_CREATING,
    component: dynamic(
      () =>
        import(
          /* webpackChunkName: "video-creating" */
          '../pages/VideoCreating/VideoCreating'
        ),
    ),
    requireLogin: true,
    requireSessionId: true,
  },
  {
    path: RoutePath.REVIEW_VIDEO,
    component: dynamic(
      () =>
        import(
          /* webpackChunkName: "review-video" */
          '../pages/ReviewVideo/ReviewVideo'
        ),
    ),
    requireLogin: true,
    requireSessionId: true,
  },
  {
    path: RoutePath.FINAL_PAGE,
    component: dynamic(
      () =>
        import(
          /* webpackChunkName: "final-page" */
          '../pages/FinalPage/FinalPage'
        ),
    ),
    requireLogin: true,
    requireSessionId: true,
  },
  {
    path: RoutePath.SITE_PREVIEW,
    component: dynamic(
      () =>
        import(
          /* webpackChunkName: "site-preview" */
          '../pages/SitePreview/SitePreview'
        ),
    ),
    requireLogin: true,
    requireSessionId: false,
  },
];

export { RoutePath };
export default wizardRoutes;
